export async function articleCompletionSource(context) {
  const match = context.matchBefore(/\[#a\s+[\w-]*/)
  if (!match) return null
  if (match.from === match.to && !context.explicit) return null

  const prefix = "[#a "
  // match.text contains the full matched string
  const query = match.text.slice(prefix.length)

  try {
    const res = await fetch(`/api/v1/autocomplete/articles.json?query=${encodeURIComponent(query)}`, {
      headers: {
        "content-type": "application/json"
      }
    })
    const json = await res.json()

    return {
      from: match.from + prefix.length,
      options: json["articles"].map(article => ({
        label: article.alias,
        type: "article"
      }))
    }
  } catch(err) {
    if (err.name !== "AbortError") throw err
  }
}
